import React, { useEffect, useState } from 'react'
import TextImageBanner from '../../components/common/TextImageBanner'
import BlogDetailHeroSection from '../../components/UserComponents/blogdetails/BlogDetailHeroSection'
import BlogDetailArticleSection from '../../components/UserComponents/blogdetails/BlogDetailArticleSection'
import BlogDetailsServiceList from '../../components/UserComponents/blogdetails/BlogDetailsServiceList'
import BlogDetailLeaveMessageForm from '../../components/UserComponents/blogdetails/BlogDetailLeaveMessageForm'
import BlogDetailSideSticky from '../../components/UserComponents/blogdetails/BlogDetailSideSticky'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import BlogDetailsSkeleton from '../../components/UserComponents/blogdetails/BlogDetailsSkeleton'
import image from "../../Assets/Home/MainHome/home3.png"

const BlogDetails = () => {
  const { id } = useParams()
  const [blogData, setBlogData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)


  const fetchBlog = async () => {
    try {
      setLoading(true)
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/blog/get-blog/${id}`,
        // { withCredentials: true }
      )
      if (response.data.success) {
        setBlogData(response.data.data)
      }
    } catch (error) {
      console.log(`Failed to fetch blog detail: ${error}`)
      setError(error.message || 'Failed to fetch blog detail.')
    } finally {
      setLoading(false)
    }
  }

  // console.log(blogData)

  useEffect(() => {
    fetchBlog()
  }, [])

  return (
    <div>
      <TextImageBanner label='Blog Details' bgImage={[
        `${image}`,
        `${image}`,
        `${image}`,
      ]} />
      <div className="md:px-10 px-6 py-20 max-w-7xl relative flex flex-col-reverse lg:flex-row xl:gap-14 gap-10">
        {loading ? <BlogDetailsSkeleton /> : <div className="lg:w-[70%] w-full flex flex-col gap-y-5">
          <BlogDetailHeroSection blogData={blogData} />
          <BlogDetailArticleSection blogData={blogData} />
          <BlogDetailsServiceList blogData={blogData} />
          <BlogDetailLeaveMessageForm />
        </div>}
        <BlogDetailSideSticky />
      </div>
    </div>
  )
}

export default BlogDetails